import { apiClient } from '@/core/apiClient';

export type EmailContactImport = {
  id: number;
  filename: string;
  sourceType: string;
  description?: string | null;
  status:
    | 'UPLOADED'
    | 'ANALYZING'
    | 'READY'
    | 'IMPORTING'
    | 'COMPLETED'
    | 'COMPLETED_WITH_ERRORS'
    | 'FAILED'
    | 'CANCELLED';
  totalRows: number;
  validRows: number;
  invalidRows: number;
  newContacts: number;
  existingContacts: number;
  duplicateRows: number;
  suppressedContacts: number;
  createdAt: string;
  completedAt?: string | null;
  errorMessage?: string | null;
};

export type AnalyzeResult = {
  totalRows: number;
  validRows: number;
  invalidRows: number;
  newContacts: number;
  existingContacts: number;
  duplicateRows: number;
  suppressedContacts: number;
  sample: Array<{ row: number; email: string; name?: string; classification: string; reason?: string }>;
};

export const emailImportsApi = {
  upload: async (file: File, sourceType: string, description?: string): Promise<{ importId: number; duplicateOfImportId: number | null }> => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('sourceType', sourceType);
    if (description) fd.append('description', description);
    const res = await apiClient.post('/admin/email-imports/upload', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },

  analyze: async (importId: number): Promise<AnalyzeResult> => {
    const res = await apiClient.post(`/admin/email-imports/${importId}/analyze`);
    return res.data;
  },

  findById: async (importId: number): Promise<EmailContactImport> => {
    const res = await apiClient.get(`/admin/email-imports/${importId}`);
    return res.data;
  },

  confirm: async (importId: number): Promise<EmailContactImport> => {
    const res = await apiClient.post(`/admin/email-imports/${importId}/confirm`);
    return res.data;
  },

  cancel: async (importId: number): Promise<EmailContactImport> => {
    const res = await apiClient.post(`/admin/email-imports/${importId}/cancel`);
    return res.data;
  },

  list: async (page = 1, pageSize = 20): Promise<{ items: EmailContactImport[]; total: number }> => {
    const res = await apiClient.get('/admin/email-imports', { params: { page, pageSize } });
    return res.data;
  },

  downloadErrors: async (importId: number): Promise<Blob> => {
    const res = await apiClient.get(`/admin/email-imports/${importId}/errors.csv`, { responseType: 'blob' });
    return res.data;
  },
};
